// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import App from './App';
import router from './router';
import store from './store';
// import axios from 'axios';
// import VueAxios from 'vue-axios';
import i18n from './lang/i18n';
// import VueI18n from 'vue-i18n';
import Toasted from 'vue-toasted';
import Select2 from 'v-select2-component';
import Paginate from 'vuejs-paginate';
import VeeValidate, {Validator} from 'vee-validate';

import ja from 'vee-validate/dist/locale/ja';

// import JQuery from 'jquery';

import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'font-awesome/css/font-awesome.css';
import 'nprogress/nprogress.css';

import '@/assets/js/main.js';

// Install BootstrapVue
Vue.use(BootstrapVue);

/* Toasted */
Vue.use(Toasted, {
    theme: "bubble",
    position: "bottom-right",
    singleton: true,
    iconPack: 'fontawesome',
    duration: 3000,
});

/* VeeValidate */
Validator.localize('ja', ja);
Vue.use(VeeValidate, {
    locale: 'ja',
});

/* Select2 */
Vue.component('select2', Select2);

/* Paginate */
Vue.component('paginate', Paginate);

/*
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'ja'
});

Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    ja
  }
});
*/

Vue.config.productionTip = false;

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>',
});

export default app;



// WEBPACK FOOTER //
// ./src/main.js